import Vue from 'vue'
import localforage from 'localforage'
import jscookie from 'js-cookie'
import {signinRoute,userTokenStorageKey} from './config'

export const beforeCreateVueInstance = [(store,router) => {

  store.dispatch('checkUser')

  router.beforeEach((to, from, next) => {
    if(to.meta.requiresAuth&&!store.getters.currentUser){
      store.dispatch('checkUser')
        .then(() => {
          // There is a token and it is valid
          next() // can access the route
        })
        .catch(() => {
          // No token, or it is invalid
          next(signinRoute) // redirect to login
        });
      return;
    }
    next();
  });

  store.watch(()=>store.getters['getAuthToken'],(newToken,oldToken)=>{
    localforage.setItem(userTokenStorageKey, newToken);
    newToken?
      jscookie.set(userTokenStorageKey, newToken, { expires: 1 }):
      jscookie.remove(userTokenStorageKey);
  });

  //Настройка плагина axios
  if (Vue.axios) {
    // https://github.com/mzabriskie/axios#interceptors
    Vue.axios.interceptors.response.use(
      response => response,
      error => {
        const  response  = error;
        /**
         * If token is either expired, not provided or invalid
         * then redirect to login. On server side the error
         * messages can be changed on app/Providers/EventServiceProvider.php
         */
        // if (response.response&&[401, 400, 403].indexOf(response.response.status) > -1) {
        //   router.push(signinRoute)
        // }
       return Promise.reject(error)
      }
    )
  }

  const updateToken = (newValue,oldValue)=>{
      if (Vue.axios) {//Настройка плагина axios
          //if (newValue) Vue.axios.defaults.headers.common.Authorization = `Bearer ${newValue}`;
          //else delete Vue.axios.defaults.headers.common.Authorization

        if (newValue) Vue.axios.defaults.headers.common['Authorization'] = `Bearer ${newValue}`;
        else delete Vue.axios.defaults.headers.common.Authorization
      }

      if (Vue.Remote){
          var requestParams =  Vue.Remote.getRequestParam() || {};

          newValue?requestParams.token=newValue:delete requestParams.token;

          Vue.Remote.setRequestParam(requestParams);
      }

  };

    //Первоначальная настройка
    updateToken(store.getters['getAuthToken'],null);

    store.watch(()=>store.getters['getAuthToken'],updateToken)

}];

